<!--
 * @Author: zhaoliang
 * @Date: 2024-05-20 16:02:28
 * @LastEditTime: 2025-10-10 17:28:04
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/MyTrips/index.vue
 *
-->
<template>
  <div class="h-box">
    <h2 class="global-title">
      <span>{{ $t('mbs-select-mytrips') }}</span>
      <!-- <img src="~img/icon-help.svg" alt="" @click="$router.push('/faqs')" /> -->
      <div class="help-wrapper" @click="showHelpFaq = !showHelpFaq" role="help">
        <span class="icon-help" :class="{ 'icon-help-close': showHelpFaq }"></span>
      </div>
      <template v-if="showHelpFaq">
        <div class="help-box" :style="{ maxHeight: minHeight }">
          <h2><span class="icon-help-reverse"></span> {{ $t('tips-title') }}</h2>
          <template v-for="item in faqlist">
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </template>
        </div>
      </template>
    </h2>
    <div class="h-box-content" v-if="haveData">
      <div class="h-box-content-item">
        <div class="h-box-content-item-title" @click="changeShowUpcoming">
          <span>{{ $t('mytrips-upcoming-title') }}</span>
          <img :class="{ close: !showUpcoming }" src="~img/icon-down-arrow-min.svg" alt="" />
        </div>
        <div class="h-box-content-item-content" v-if="showUpcoming">
          <div v-if="upcomingList && upcomingList.length > 0">
            <div
              class="list-item"
              v-for="item in upcomingList"
              :key="item.OrderNo"
              @click="goDetail(item)"
            >
              <img class="item-coverimg" :src="item.imageUrl" alt="" />
              <div class="item-info">
                <p class="item-info-title">{{ item.serviceDateTime }}, {{ item.serviceTime }}</p>
                <p class="item-info-main">{{ item.subTitle }}</p>
                <p class="item-info-aiport">{{ item.airportName }}</p>
              </div>
              <div class="item-more">
                <img src="~img/icon-up-arrow-min.svg" alt="icon-more" />
              </div>
            </div>
          </div>
          <div class="h-box-content-item-empty" v-else>
            <img src="@/components/LeftAccount/images/icon-booking-empty.svg" alt="" />
            <p>{{ $t('mytrips-upcoming-not-available') }}</p>
          </div>
        </div>
      </div>
      <div class="h-box-content-item">
        <div class="h-box-content-item-title" @click="changeShowPast">
          <span>{{ $t('mytrips-past-title') }}</span>
          <img :class="{ close: !showPast }" src="~img/icon-down-arrow-min.svg" alt="" />
        </div>
        <div class="h-box-content-item-content" v-if="showPast">
          <div v-if="pastList && pastList.length > 0">
            <div
              class="list-item"
              v-for="item in pastList"
              :key="item.OrderNo"
              @click="goDetail(item)"
            >
              <img class="item-coverimg" :src="item.imageUrl" alt="" />
              <div class="item-info">
                <p class="item-info-title">{{ item.serviceDateTime }}</p>
                <p class="item-info-main">{{ item.subTitle }}</p>
                <p class="item-info-aiport">{{ item.airportName }}</p>
              </div>
              <div class="item-more expired">
                <img src="~img/icon-up-arrow-min.svg" alt="icon-more" />
              </div>
            </div>
          </div>
          <div class="h-box-content-item-empty" v-else>
            <img src="@/components/LeftAccount/images/icon-booking-empty.svg" alt="" />
            <p>{{ $t('mytrips-past-not-available') }}</p>
          </div>
        </div>
      </div>
      <div class="h-box-content-item">
        <div class="h-box-content-item-title" @click="changeShowCancelled">
          <span>{{ $t('mytrips-cancelled-title') }}</span>
          <img :class="{ close: !showCancelled }" src="~img/icon-down-arrow-min.svg" alt="" />
        </div>
        <div class="h-box-content-item-content" v-if="showCancelled">
          <div v-if="cancelledList && cancelledList.length > 0">
            <div
              class="list-item"
              v-for="item in cancelledList"
              :key="item.OrderNo"
              @click="goDetail(item)"
            >
              <img class="item-coverimg" :src="item.imageUrl" alt="" />
              <div class="item-info">
                <p class="cancelled-tips">{{ $t('mytrips-cancelled-tips') }}</p>
                <p class="item-info-title">{{ item.serviceDateTime }}, {{ item.serviceTime }}</p>
                <p class="item-info-main">{{ item.subTitle }}</p>
                <p class="item-info-aiport">{{ item.airportName }}</p>
              </div>
              <div class="item-more expired">
                <img src="~img/icon-up-arrow-min.svg" alt="icon-more" />
              </div>
            </div>
          </div>
          <div class="h-box-content-item-empty" v-else>
            <img src="@/components/LeftAccount/images/icon-booking-empty.svg" alt="" />
            <p>{{ $t('mytrips-cancelled-not-available') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="h-box-content-empty" v-else>
      <img src="@/components/LeftAccount/images/icon-booking-empty.svg" alt="" />
      <p>{{ $t('mytrips-no-booking') }}</p>
    </div>
  </div>
</template>
<script>
  import { mapMutations, mapState } from 'vuex';

  export default {
    name: 'MyTrips',
    components: {},
    props: {
      minHeight: {
        type: String,
        default: '0px',
      },
    },
    data() {
      return {
        showUpcoming: false,
        upcomingList: [],
        showPast: false,
        pastList: [],
        showCancelled: false,
        cancelledList: [],
        showHelpFaq: false,
        faqlist: [],
      };
    },
    computed: {
      haveData() {
        return (
          (this.upcomingList && this.upcomingList.length > 0) ||
          (this.pastList && this.pastList.length > 0) ||
          (this.cancelledList && this.cancelledList.length > 0)
        );
      },
      ...mapState(['userInfo']),
    },
    mounted() {
      this.getUpcomingList(true);
      this.getPastList();
      this.getCancelledList();
      this.getFaqs();
    },
    methods: {
      ...mapMutations(['showMessageModal']),
      getUpcomingList(isFirstTimeRequest) {
        this.$http.account
          .getTripsList({
            status: 8,
            lang: localStorage.getItem('lang'),
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.upcomingList = res.payload?.data || [];
              if (isFirstTimeRequest) {
                this.showUpcoming = (res.payload?.data && res.payload?.data.length > 0) || false;
              }
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
              this.upcomingList = [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getPastList() {
        this.$http.account
          .getTripsList({
            status: 2,
            lang: localStorage.getItem('lang'),
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.pastList = res.payload?.data || [];
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
              this.pastList = [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getCancelledList() {
        this.$http.account
          .getTripsList({
            status: 3,
            lang: localStorage.getItem('lang'),
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.cancelledList = res.payload?.data || [];
            } else {
              this.showMessageModal({
                key: res.note,
                i18nNeed: false,
              });
              this.cancelledList = [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getFaqs() {
        this.$http.account
          .getHelpIcon({
            type: 3,
            lang: localStorage.getItem('lang'),
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
          })
          .then(res => {
            if (res.state === '11') {
              this.faqlist = res.payload?.contents || [];
            }
          });
      },
      changeShowUpcoming() {
        this.showUpcoming = !this.showUpcoming;
        if (this.showUpcoming) {
          this.getUpcomingList(false);
          this.getPastList();
          this.getCancelledList();
        }
      },
      changeShowPast() {
        this.showPast = !this.showPast;
        if (this.showPast) {
          this.getUpcomingList(false);
          this.getPastList();
          this.getCancelledList();
        }
      },
      changeShowCancelled() {
        this.showCancelled = !this.showCancelled;
        if (this.showCancelled) {
          this.getUpcomingList(false);
          this.getPastList();
          this.getCancelledList();
        }
      },
      goDetail(item) {
        this.$router.push({
          path: 'tripsDetail',
          query: {
            orderNo: item.orderNo,
          },
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .h-box {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .help-wrapper {
        margin-left: 5px;
        cursor: pointer;
        z-index: 4;

        .icon-help {
          display: block;
          width: 40px;
          height: 40px;
          background: url('~img/icon-help.svg') no-repeat center;
          background-size: 40px 40px;

          &.icon-help-close {
            background: url('~img/icon-help-close-web.svg') no-repeat center;
            background-size: 40px 40px;
          }
        }
      }
      .help-box {
        position: absolute;
        width: 500px;
        top: 20px;
        right: 20px;
        z-index: 3;
        padding: 20px 24px;
        color: #fff;
        text-align: left;
        background: #163049;
        border-radius: 8px;
        @include font($size: 20px, $weight: 400);

        .icon-help-reverse {
          display: block;
          width: 30px;
          height: 30px;
          background: url('~img/icon-help-reverse.svg') no-repeat center;
          background-size: 30px 30px;
        }

        h2,
        h3,
        p {
          margin-bottom: 15px;
          line-height: 1.5;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          span {
            margin-right: 5px;
          }
        }
      }
    }

    .h-box-content {
      .h-box-content-item {
        border-bottom: 1px solid #ced5d9;
        .h-box-content-item-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 10px 0px;
          height: 50px;
          cursor: pointer;
          span {
            @include font(21px, 700);
            line-height: 26px;
          }
          img {
            &.close {
              transform: rotate(-90deg);
            }
          }
        }

        .h-box-content-item-content {
          padding-bottom: 20px;
          .list-item {
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-radius: 8px;
            box-sizing: border-box;
            overflow: hidden;
            margin-bottom: 20px;

            .item-coverimg {
              width: 240px;
              height: 156px;
            }
            .item-info {
              flex: 1;
              padding: 30px 40px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 156px;
              // box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.2);
              border-top: 1px solid #eeeeee;
              border-bottom: 1px solid #eeeeee;

              .cancelled-tips {
                color: #cc2222;
                @include font(14px, 600);
              }

              .item-info-title {
                @include font(18px, 600);
              }
              .item-info-main {
                @include font(28px, 600);
              }
              .item-info-aiport {
                @include font(18px, 400);
              }
            }
            .item-more {
              width: 50px;
              height: 156px;
              background-color: #c29d5c;
              @include flex(row, center, center);

              &.expired {
                background-color: #9eacb5;
              }

              img {
                width: 30px;
                height: 30px;
                transform: rotate(90deg);
              }
            }
          }
          .h-box-content-item-empty {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 80px;
              height: 80px;
              margin-right: 20px;
            }

            p {
              color: #7f898f;
              @include font(24px, 400);
            }
          }
        }
      }
    }

    .h-box-content-empty {
      padding-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      img {
        width: 140px;
        height: 140px;
      }
      p {
        color: #7f898f;
        @include font(26px, 400);
        line-height: 30px;
        margin-top: 24px;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .h-box {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 12px;
        padding: 0;

        .help-wrapper {
          .icon-help {
            width: 30px;
            height: 30px;
            background-size: 30px 30px;

            &.icon-help-close {
              background-size: 30px 30px;
            }
          }
        }
        .help-box {
          top: 15px;
          right: 15px;
          width: 300px;
          padding: 16px 20px;
          @include font($size: 12px, $weight: 400);

          .icon-help-reverse {
            width: 20px;
            height: 20px;
            background-size: 20px 20px;
          }

          h2,
          h3,
          p {
            margin-bottom: 10px;
            line-height: 16px;
          }
        }
      }

      .h-box-content {
        .h-box-content-item {
          .h-box-content-item-title {
            span {
              @include font(18px, 700);
            }
          }

          .h-box-content-item-content {
            padding-bottom: 20px;
            .list-item {
              cursor: pointer;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              border-radius: 8px;
              box-sizing: border-box;
              overflow: hidden;
              margin-bottom: 20px;

              .item-coverimg {
                width: 70px;
                height: 100px;
              }
              .item-info {
                padding: 10px;
                height: 100px;
                justify-content: space-around;

                .cancelled-tips {
                  @include font(12px, 600);
                }
                .item-info-title {
                  @include font(12px, 600);
                }
                .item-info-main {
                  @include font(14px, 600);
                }
                .item-info-aiport {
                  @include font(12px, 400);
                }
              }
              .item-more {
                width: 30px;
                height: 100px;

                img {
                  width: 20px;
                  height: 20px;
                  transform: rotate(90deg);
                }
              }
            }
            .h-box-content-item-empty {
              img {
                width: 40px;
                height: 40px;
                margin-right: 20px;
              }

              p {
                color: #7f898f;
                @include font(16px, 400);
              }
            }
          }
        }
      }

      .h-box-content-empty {
        img {
          width: 100px;
          height: 100px;
        }
        p {
          @include font(16px, 400);
          line-height: 22px;
          margin-top: 16px;
        }
      }
    }
  }
</style>
